import { gql } from "@apollo/client";

export const getEmployees = gql`
  query Employees {
    rows: employees {
      employee_id
      employee_first_name
      employee_last_name
      employee_phonenumber
      employee_email
      emp_abbrv
      should_sign
      signature
      user {
        broker_role {
          position
          broker_role_id
        }
      }
    }
    count: getEmployeesCount
  }
`;

export const getRoles = gql`
query BrokerRoles {
  rows: getBrokerRoles {
    broker_role_id
    position
    privileges
  }
  count: getBrokerRolesCount
}
`;


export const getRole = gql`
query GetBrokerRole($brokerRoleId: ID!) {
  getBrokerRole(broker_role_id: $brokerRoleId) {
    broker_role_id
    position
    privileges
  }
}
`;

export const getEmployee = gql`
  query Employee($employeeId: ID) {
    employee(employee_id: $employeeId) {
      employee_id
      employee_first_name
      employee_last_name
      employee_phonenumber
      employee_email
      emp_abbrv
      should_sign
      signature
      user {
        broker_role {
          position
          broker_role_id
        }
      }
    }
  }
`;
